import React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@omni/components/components/Checkout/CheckoutCustomer/checkoutCustomer.container"
    ).then((module) => ({ default: module.CheckoutCustomerContainer }))
);
